import React, { useEffect } from "react";
import Header from "./Component/Header";
import NavBar from "./Component/NavBar";
import { Link, useNavigate } from "react-router-dom";
import Footer from "./Component/Footer";
const Admin=()=>{

    const navigate=useNavigate();
    useEffect(()=>{
        const login=localStorage.getItem("admin")
        console.log("user",login);
        if(login!=="Modern Admin"){
            navigate('/Login');
        }
    },[navigate]);

    return(
    <>
    <Header />
    <div className="w-100">
        <NavBar />
        <>
        <div className="text-center m-3">
        <Link to='/Imagetest' ><button class="btn btn-outline-success m-2 btn-lg">Home</button></Link>
        <Link to='/GImage' ><button class="btn btn-outline-success m-2 btn-lg">Gallery</button></Link>
            </div>
            <Footer />
            </>
    </div>

    </>
    );
};
export default Admin;